module.exports = __webpack_public_path__ + "static/media/declinedRejected.056775bd.svg";